import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { transformResponseHandler } from "../../Utils/transformResponse";
import ApiRoutes from "../../Utils/ApiRoutes";
import { apiEncrypted } from "../../Utils/function";

export const AuditsApis = createApi({
  reducerPath: "AuditsApis",
  baseQuery: async (args, api, extraOptions) => {
    const result = apiEncrypted(args, api, extraOptions)
    return result;   
  }, endpoints: (builder) => ({
    getAudits: builder.query({
      query: ({
        search,
        limit,
        page,
        rrb_id,
        state_id,
        city_id,
        centre_id,
        user_id,
        status,
        start_date,
        end_date,
        cen_id,
        audit_status,
      }) => ({
        url: `${ApiRoutes.getAudits}`,
        method: "GET",
        params: {
          search: search ?? "",
          limit,
          page,
          rrb_id,
          state_id,
          city_id,
          // centre_id,
          user_id,
          status,
          startDate: start_date,
          endDate: end_date,
          cen_id,
          audit_status,
        },
      }),
      providesTags:["getAudit"],
      transformResponse: (res, meta) =>
        transformResponseHandler(res, meta, false),
      transformErrorResponse: (error, meta) =>
        transformResponseHandler(error, meta, true),
    }),
    getViewAudits: builder.query({
      query: ({ centre_id }) => ({
        url: `${ApiRoutes.getViewAudit}/${centre_id}`,
        method: "GET",
        // body: body
      }),
      transformResponse: (res, meta) =>
        transformResponseHandler(res, meta, false),
      transformErrorResponse: (error, meta) =>
        transformResponseHandler(error, meta, true),
    }),
    getmyAudits: builder.query({
      query: ({
        search,
        limit,
        page,
        rrb_id,
        state_id,
        city_id,
        centre_id,
        user_id,
        status,
        // start_date,
        // end_date,
        cen_id
      }) => ({
        url: `${ApiRoutes.getmyAudits}`,
        method: "GET",
        params: {
          search: search ?? "",
          limit,
          page,
          rrb_id,
          state_id,
          city_id,
          // centre_id,
          user_id,
          status,
          // startDate: start_date,
          // endDate: end_date,
          cen_id,
        },
      }),
      providesTags:["getAudit"],
      transformResponse: (res, meta) =>
        transformResponseHandler(res, meta, false),
      transformErrorResponse: (error, meta) =>
        transformResponseHandler(error, meta, true),
    }),
    cancelAudits: builder.mutation({
      query: ({ id }) => ({
        url: `${ApiRoutes.cancelAudits}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags:["getAudit"],
      transformResponse: (res, meta) =>
        transformResponseHandler(res, meta, true),
      transformErrorResponse: (error, meta) =>
        transformResponseHandler(error, meta, true),
    }),
    acceptAudit: builder.mutation({
      query: ({id,}) => ({
        url: `${ApiRoutes.acceptAudit}/${id}`,
        method: "PUT",
        // body: data,
      }),
      invalidatesTags:["getAuditsFormExtrasApis"],
      transformResponse: (res, meta) => transformResponseHandler(res, meta, true),
      transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
    }),
    rejectAudit: builder.mutation({
      query: ({id,data}) => ({
        url: `${ApiRoutes.rejectAudit}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags:["getAuditsFormExtrasApis"],
      transformResponse: (res, meta) => transformResponseHandler(res, meta, true),
      transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
    }),
    partialApproveAudit: builder.mutation({
      query: ({id,...data}) => ({
        url: `${ApiRoutes.partialApproveAudit}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags:["getAuditsFormExtrasApis"],
      transformResponse: (res, meta) => transformResponseHandler(res, meta, true),
      transformErrorResponse: (error, meta) => transformResponseHandler(error,meta, true),
    }),
  }),
});

export const {
  useGetAuditsQuery,
  useGetmyAuditsQuery,
  useGetViewAuditsQuery,
  useCancelAuditsMutation,
  useAcceptAuditMutation,
  useRejectAuditMutation,
  usePartialApproveAuditMutation
} = AuditsApis;
